import { UPDATE_QUESTION } from '../actionTypes'

export const updateQuestion = (data: object) => ({
  type: UPDATE_QUESTION.name,
  api: {
    url: 'faq/update',
    data,
  },
})
